import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLang } from '../../contexts/LanguageContext';
import { useAuth } from '../../contexts/AuthContext';
import './Paywall.css';

const Paywall = ({ errorType = 'REGISTER_REQUIRED' }) => {
  const { t } = useLang();
  const { user } = useAuth();
  const navigate = useNavigate();

  // Determinar los textos de forma dinámica
  let title = t('PAYWALL_TITLE') || '¡La aventura no termina aquí!';
  let message = t('PAYWALL_MESSAGE') || 'Has completado el capítulo de cortesía. Únete a Readerum para desbloquear el resto del libro, guardar tu progreso y acceder a herramientas lingüísticas avanzadas.';
  let actions = null;

  if (errorType === 'BOOK_NOT_IN_LIST' || (user && errorType === 'REGISTER_REQUIRED')) {
    title = t('PAYWALL_FREE_LIST_TITLE') || '¡Amplía tu biblioteca!';
    message = t('PAYWALL_FREE_LIST_MESSAGE') || 'En el plan gratuito puedes leer un libro completo a la vez. Agrega este libro a tu lista de lectura para desbloquearlo, o hazte Premium para leer todo el catálogo de manera ilimitada.';
    actions = (
      <div className="paywall-actions">
        <button onClick={() => navigate('/checkout')} className="paywall-btn-register">
          {t('PRICING_PLAN_PREMIUM_CTA') || 'Hazte Premium'}
        </button>
        <button onClick={() => navigate('/list')} className="paywall-btn-login">
          {t('PAYWALL_GO_TO_LIST_BTN') || 'Ver Mi Lista'}
        </button>
        <button onClick={() => navigate('/home')} className="paywall-btn-back">
          {t('PAYWALL_BACK_BTN') || 'Volver al catálogo'}
        </button>
      </div>
    );
  } else if (errorType === 'AUDIO_PREMIUM_ONLY') {
    title = t('PAYWALL_AUDIO_PREMIUM_TITLE') || '¡Sigue escuchando!';
    message = t('PAYWALL_AUDIO_PREMIUM_MESSAGE') || 'La lectura inmersiva con audio sincronizado y voz profesional a partir del capítulo 4 es una característica exclusiva de Readerum Premium. ¡Sube de nivel para continuar la inmersión!';
    actions = (
      <div className="paywall-actions">
        <button onClick={() => navigate('/checkout')} className="paywall-btn-register">
          {t('PRICING_PLAN_PREMIUM_CTA') || 'Hazte Premium'}
        </button>
        <button onClick={() => navigate('/home')} className="paywall-btn-back">
          {t('PAYWALL_BACK_BTN') || 'Volver al catálogo'}
        </button>
      </div>
    );
  } else if (errorType === 'DICT_LIMIT_REACHED') {
    title = t('PAYWALL_DICT_LIMIT_TITLE') || '¡Aprende sin límites!';
    message = t('PAYWALL_DICT_LIMIT_MESSAGE') || 'Has alcanzado tu límite gratuito de 5 consultas diarias de diccionario. Consigue consultas de vocabulario ilimitadas, transcripción fonológica avanzada y más con Readerum Premium.';
    actions = (
      <div className="paywall-actions">
        <button onClick={() => navigate('/checkout')} className="paywall-btn-register">
          {t('PRICING_PLAN_PREMIUM_CTA') || 'Hazte Premium'}
        </button>
        <button onClick={() => navigate('/home')} className="paywall-btn-back">
          {t('PAYWALL_BACK_BTN') || 'Volver al catálogo'}
        </button>
      </div>
    );
  } else {
    // Caso por defecto: Invitado (REGISTER_REQUIRED)
    actions = (
      <div className="paywall-actions">
        <a href="/register" className="paywall-btn-register">
          {t('PAYWALL_REGISTER_BTN') || 'Crear Cuenta Gratis'}
        </a>
        <a href="/login" className="paywall-btn-login">
          {t('PAYWALL_LOGIN_BTN') || 'Iniciar Sesión'}
        </a>
        <button onClick={() => navigate('/home')} className="paywall-btn-back">
          {t('PAYWALL_BACK_BTN') || 'Volver al catálogo'}
        </button>
      </div>
    );
  }

  return (
    <div className="paywall-overlay">
      <div className="paywall-container">
        <div className="paywall-icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 19.5C4 18.837 4.26339 18.2011 4.73223 17.7322C5.20107 17.2634 5.83696 17 6.5 17H20V2H6.5C5.83696 2 5.20107 2.26339 4.73223 2.73223C4.26339 3.20107 4 3.83696 4 4.5V19.5Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M4 19.5C4 20.8807 5.11929 22 6.5 22H20" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M14 2V10L16 8.5L18 10V2H14Z" fill="#D4AF37" />
          </svg>
        </div>
        <h2 className="paywall-title">{title}</h2>
        <p className="paywall-message">{message}</p>
        {actions}
      </div>
    </div>
  );
};

export default Paywall;
